import { useFormik } from "formik";
import * as Yup from "yup";
import { Link as ReactLink, useNavigate } from "react-router-dom";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import { useLoginMutation } from "@/app/features/auth/authApiSlice";
import { useDispatch } from "react-redux";
import { setCredentials } from "@/app/features/auth/authSlice";

const LoginPage = () => {
  const [login, { isLoading }] = useLoginMutation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      submit: null,
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Must be a valid email")
        .max(255)
        .required("Email is required"),
      password: Yup.string().max(255).required("Password is required"),
    }),
    onSubmit: async (values, helpers) => {
      try {
        const { data, error } = await login({
          email: values.email,
          password: values.password,
        });

        if (error) {
          helpers.setStatus({ success: false });
          helpers.setErrors({ submit: error?.data?.message });
          helpers.setSubmitting(false);
          return;
        }

        dispatch(
          setCredentials({
            email: data.data.user.email,
            isAdmin: data.data.user.isAdmin,
            token: data.accessToken,
            name: data.data.user.name,
          })
        );
        navigate("/");
      } catch (err) {
        console.log(err);
        helpers.setStatus({ success: false });
        helpers.setErrors({ submit: err.message });
        helpers.setSubmitting(false);
      }
    },
  });

  return (
    <Box
      sx={{
        backgroundColor: "background.paper",
        flex: "1 1 auto",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          maxWidth: 550,
          px: 3,
          py: "100px",
          width: "100%",
        }}
      >
        <Stack spacing={1} sx={{ mb: 3 }}>
          <Typography variant="h4">Login</Typography>
        </Stack>
        <form noValidate onSubmit={formik.handleSubmit}>
          <Stack spacing={3}>
            <TextField
              error={!!(formik.touched.email && formik.errors.email)}
              fullWidth
              helperText={formik.touched.email && formik.errors.email}
              label="Email Address"
              name="email"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              type="email"
              value={formik.values.email}
            />
            <TextField
              error={!!(formik.touched.password && formik.errors.password)}
              fullWidth
              helperText={formik.touched.password && formik.errors.password}
              label="Password"
              name="password"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              type="password"
              value={formik.values.password}
            />
          </Stack>

          {formik.errors.submit && (
            <Typography color="error" sx={{ mt: 3 }} variant="body2">
              {formik.errors.submit}
            </Typography>
          )}
          <Button
            fullWidth
            size="large"
            sx={{ mt: 3 }}
            type="submit"
            variant="contained"
            disabled={isLoading}
          >
            Continue
          </Button>
          <Button
            fullWidth
            size="large"
            sx={{ mt: 3 }}
            component={ReactLink}
            to="/forgot-password"
          >
            Forgot Password
          </Button>
        </form>
      </Box>
    </Box>
  );
};

export default LoginPage;
